import Vue from 'vue';

import moment from 'moment';
import { fixedComma, upperHead, formatNumber } from '@util';

Vue.filter('replace', (value, textToReplace, newText = '') => {
    if (!value) return;
    return value.replace(textToReplace, newText);
});

Vue.filter('truncStr', (value = '', max = 10) => {
    return R.ifElse(
        R.compose(
            R.gt(R.__, max),
            R.prop('length')
        ),
        R.compose(
            R.concat(R.__, '...'),
            R.take(max)
        ),
        R.identity
    )(value);
});

Vue.filter('dateFormat', (value, format = '[created on] MMM D YYYY') =>
    moment(value).format(format)
);

Vue.filter('addComma', fixedComma);
Vue.filter('upperHead', upperHead);
Vue.filter('formatNumber', formatNumber);
